<div class="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-brand-briefcream to-brand-nude">

  <div class="relative max-w-lg w-full">

    <!-- Letter shadow -->
    <div class="absolute inset-0 bg-gray-300/30 transform translate-x-1 translate-y-1 blur-sm"></div>

    <!-- Main letter -->
    <div class="relative bg-brand-briefcream border border-brand-goldline shadow-xl">

      <!-- Letter header with wax seal -->
      <div class="relative bg-gradient-to-r from-brand-briefcream via-brand-nude to-brand-briefcream p-8 ">


        <div class="text-center pt-6">
          <h1 class="font-[Parisienne] text-5xl text-brand-inktint mb-6">Tabea & Stephan</h1>
          <div class="flex items-center justify-center space-x-3 ">
            <div class="w-12 h-px bg-brand-goldline"></div>
            <span class="font-[Neuton] text-lg text-brand-inktint">Wir heiraten!</span>
            <div class="w-12 h-px bg-brand-goldline"></div>
          </div>
        </div>
      </div>

      <!-- Letter content -->
      <div class="px-8 mb-8">

        <!-- Letter greeting -->
        <div class="mb-6">
          <p class="text-brand-inktint font-[Neuton] text-base italic mb-3">
            Liebe Familie, liebe Freunde,
          </p>
          <p class="text-brand-inktint/80 font-[Neuton] ">
            Um auf die nächsten Seiten zuzugreifen, benötigt ihr das Zugangswort aus eurer Einladung.
          </p>
        </div>

        <!-- Login form -->
        <form (ngSubmit)="onLogin()" #loginForm="ngForm">

          <div>
            <label for="accessword" class="block font-[Neuton] font-semibold text-brand-inktint mb-2 text-sm">
              Zugangswort aus der Einladung:
            </label>
            <div class="relative">
              <input id="accessword" name="accessword" [type]="showPassword() ? 'text' : 'password'"
                [(ngModel)]="accessword" required minlength="3"
                class="w-full p-4 pr-12 bg-white/80 border-b-2 border-brand-inktint focus:border-brand-inktint focus:bg-white focus:outline-brand-inktint font-[Neuton] text-brand-inktint text-center"
                style="background: linear-gradient(to right, transparent 0%, rgba(214, 179, 112, 0.1) 50%, transparent 100%);" />
              <button type="button" (click)="togglePasswordVisibility()"
                class="absolute right-3 top-1/2 transform -translate-y-1/2 text-brand-inktint/60 hover:text-brand-inktint focus:outline-none">
                @if(!showPassword()){
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L12 12m-2.122-2.122L7.757 7.757M12 12l2.122 2.122m-2.122-2.122L9.878 9.878m2.122 2.122l2.121 2.121">
                  </path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3l18 18"></path>
                </svg>
                }@else{
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z">
                  </path>
                </svg>
                }

              </button>
            </div>
          </div>

          @if (error(); as error) {
          <div class="text-red-600  text-center font-[Neuton]  p-2 m-2">
            {{ error }}
          </div>
          }
          <div class="m-8 p-4 border-t border-brand-goldline/30">
            <p class="text-xs text-brand-inktint/60 text-center font-[Neuton] italic">
              Das Zugangswort wurde mit eurer Einladung verschickt.<br>
              Bei Fragen wendet euch gerne an uns.
            </p>
          </div>

          <button type="submit" [disabled]="loading() || !loginForm.form.valid"
            class="w-full py-4 font-[Neuton] font-semibold text-brand-briefcream bg-brand-inktint border border-brand-inktint shadow-md hover:shadow-lg disabled:opacity-50">
            {{ loading() ? 'Prüfe Zugang...' : 'Zur Hochzeitsfeier' }}
          </button>

        </form>

      </div>
    </div>
  </div>
</div>